<div class="tw-min-h-screen tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-px-4">
  <div class="tw-max-w-md tw-w-full">
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-10 tw-text-center" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
      <p class="tw-text-7xl tw-font-bold tw-text-slate-900 tw-mb-2">404</p>
      <h1 class="tw-text-lg tw-font-semibold tw-text-slate-800 tw-mb-2">¡Lo sentimos! Página no encontrada</h1>
      <p class="tw-text-sm tw-text-slate-500 tw-mb-8">La página que buscas no está disponible. Es posible que se haya movido o eliminado.</p>
      <a routerLink="/"
        class="tw-inline-block tw-px-6 tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-no-underline tw-transition hover:tw-bg-blue-700"
        style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
        Regresar a Inicio
      </a>
    </div>
  </div>
</div>
